var React = require('react');

function UbuntuArrowForm (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Grupo_26","data-name":"Grupo 26","transform":"translate(-862.675 -4250.766)"},[React.createElement("path",{"id":"Trazado_78","data-name":"Trazado 78","d":"M2425.141,775.844h20.169","transform":"translate(-1562.465 3480)","fill":"none","stroke":"#b4b4b4","strokeWidth":"1","key":0}),React.createElement("path",{"id":"Trazado_79","data-name":"Trazado 79","d":"M2487.424,788.119l4.91,4.91-4.91,4.91","transform":"translate(-1609.698 3463)","fill":"none","stroke":"#b4b4b4","strokeWidth":"1","key":1})]));
}

UbuntuArrowForm.defaultProps = {"width":"20.668","height":"10.526","viewBox":"0 0 20.668 10.526"};

module.exports = UbuntuArrowForm;

UbuntuArrowForm.default = UbuntuArrowForm;
